import './RestaurantsListingSearch.css';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SearchIcon } from "../../../../resources/icons/search-v1.svg";
import { ReactComponent as ClearIcon } from "../../../../resources/icons/close.svg";
import { addQueryString, deleteQueryString } from '../../../Listing';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
import { TEXT_SEARCH_FACET_NAME } from '../../RestaurantsListing';
const commonStyles = "c1yjx1yn";
const ltrStyles = "l1s0jgs4";
const rtlStyles = "r1dk43b0";
const RestaurantsListingSearch = _ref => {
  let {
    rtl,
    searchValue,
    setSearchValue,
    placeholder,
    setListingFilter,
    eventsAnalytics,
    params
  } = _ref;
  let history = useHistory();
  const [value, setValue] = useState(searchValue);
  const handleTextInput = e => {
    const target = e.target;
    setValue(target.value);
  };
  const handleCloseClick = () => {
    setValue('');
    if (searchValue) {
      setSearchValue('');
      deleteQueryString(TEXT_SEARCH_FACET_NAME, history);
      setListingFilter();
    }
  };
  const handleKeyPress = event => {
    if ((event.key === 'Enter' || event.key === 'NumpadEnter') && value.trim() !== searchValue.trim()) {
      sendRequestHandler(value);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), value);
    }
  };
  const handleGoClick = () => {
    sendRequestHandler(value);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchInputClickAnalytics'], params), value);
  };
  const sendRequestHandler = title => {
    setValue(title);
    setSearchValue(title);
    addQueryString(TEXT_SEARCH_FACET_NAME, title, history);
    setListingFilter();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "input-search-text",
    placeholder: placeholder,
    onKeyPress: handleKeyPress,
    onChange: handleTextInput,
    value: value
  }), /*#__PURE__*/React.createElement("button", {
    disabled: !value.trim().length,
    "aria-label": placeholder || 'Discover restaurants across Dubai',
    onClick: handleGoClick,
    className: "btn-link search-icon"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), !!value.trim().length && /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseClick,
    className: "btn-link close-icon"
  }, /*#__PURE__*/React.createElement(ClearIcon, null))));
};
export default RestaurantsListingSearch;